import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate } from '../components/list_loader';
import * as marksetSegmentsApi from '../api/market_segments';
import { canEditMarketSegments } from '../permissions';

let template = require('raw-loader!../../templates/market_segments.html').default;

class MarketSegmentsScreen
  implements ListLoaderDelegate<marksetSegmentsApi.MarketSegmentData, marksetSegmentsApi.MarketSegmentData>
{
  canAdd = canEditMarketSegments();

  fetch(params: ListRequestParams) {
    return marksetSegmentsApi.list(params);
  }

  instantiate(data: marksetSegmentsApi.MarketSegmentData) {
    return data;
  }

  remove(id: string) {
    return marksetSegmentsApi.remove(id);
  }

  canRemove(data: marksetSegmentsApi.MarketSegmentData) {
    return canEditMarketSegments();
  }
}

export let marketSegments = {
  name: 'market-segments',
  viewModel: MarketSegmentsScreen,
  template: template,
};

ko.components.register(marketSegments.name, marketSegments);
